export const CURRENT_INFOPATH_SOLUTION = 'VerbaleDiRevisioneMinisteroPDFV54-xsn';

const INFOPATH_URN_PREFIX = 'office:infopath:';

/** Extracts the solution name from the `mso-infoPathSolution` processing instruction data (`''` if absent). */
export function getInfoPathSolutionName(piData: string): string {
    return piData?.split(INFOPATH_URN_PREFIX)[1]?.split(':')[0] ?? '';
}
